import React from "react";
import { TypeLabel } from "src/utils";

const TextAreaType = ({
  question,
  data,
  onChange,
  disable,
  validationErrors,
}) => {
  const handleChange = (e, regexString) => {
    const value = e.target.value;
    if (regexString) {
      regexString = regexString.replace(/^\/|\/$/g, "");
      const regex = new RegExp(regexString);
      if (regex.test(value)) {
        onChange(e);
      }
    } else {
      onChange(e);
    }
  };

  // const handleKeyPress = (e) => {
  //   if (e.key === "Enter") {
  //     e.preventDefault();
  //   }
  // };

  return (
    <>
      {disable ? (
        <>{data ? data : ""}</>
      ) : (
        <>
          <textarea
            className={`form-control ${
              validationErrors?.[question?.id] ? "is-invalid" : ""
            }`}
            id={question?.id}
            placeholder={question?.placeholder || `Enter ${question?.label}`}
            name={question?.id}
            disabled={disable}
            style={{ width: "100%", height: "100px", resize: "vertical" }}
            value={data || ""}
            onChange={(e) => handleChange(e, question?.textValidation)}
          />
          {validationErrors?.[question?.id] && (
            <div className="invalid-feedback">
              {validationErrors?.[question?.id]}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default TextAreaType;
